import React from "react";

import { OIDCContext } from "./hooks";
import Routes from "./Routes";

function App(): React.JSX.Element {
  return (
    <OIDCContext>
      <Routes />
    </OIDCContext>
  );
}

export default App;
